<template>
    <div style="width:100%;height:100%;">
        <div class="liquidfillChart"></div>
    </div>
</template>

<script>
  import "@/utils/echarts-liquidfill.min.js"

  export default {
    name: "ZEchartsPercentage",
    props:{
      index: {
        type: Number,
        default: 0
      },
      percent:{
        type:Number,
        default:0
      },
      color:{
        type:String,
        default:'#11E9AA'
      },
      title:{
        type:String,
        default:''
      }
    },
    data() {
      return {}
    },
    watch:{
      percent(newVlaue,oldValue){
        this.setInitEcharts();
      }
    },
    methods: {
      setInitEcharts() {
        var eqpChart = this.$echarts.init(document.getElementsByClassName('liquidfillChart')[this.index]);
        var value = this.percent;
        var data = [value, value, value,];
        var options = {
          backgroundColor: 'transparent',
          title: {
            text: (value * 100).toFixed(0) + '{a|%}',
            // text: value,
            textStyle: {
              fontSize: '14',
              fontFamily: 'Microsoft Yahei',
              fontWeight: 'normal',
              color: '#fff',
              rich: {
                a: {
                  fontSize: '14',
                }
              }
            },
            x: 'center',
            y: '35%'
          },
          graphic: [{
            type: 'group',
            left: '35%',
            top: '25%',
            children: [{
              type: 'text',
              z: 100,
              left: '10',
              top: 'middle',
              style: {
                fill: '#fff',
                text: this.title,
                font: '0.8em Microsoft YaHei'
              }
            }]
          }],
          series: [{
            type: 'liquidFill',
            radius: '92%',
            center: ['50%', '50%'],
            color: [this.color, this.color, this.color],
            data: data,
            outline: {
                // show: false
                borderDistance: 2,
                itemStyle: {
                    borderWidth: 2,
                    borderColor: this.color,
                },
            },
            backgroundStyle: {
              borderWidth: 1,
              borderColor: this.color,
              color: '#275FA6'
            },
            label: {
              normal: {
                formatter: '',
              }
            }
          }]
        };
        eqpChart.setOption(options, true);
        window.addEventListener("resize", function () {
          eqpChart.resize();
        });

      }
    },
    mounted() {
        this.setInitEcharts();
    },
    created() {

    }
  }
</script>

<style scoped>
    .liquidfillChart {
        width: 100%;
        height: 100%;
    }
</style>